import React from 'react'

import ThanxAIHelpLinks from 'components/AI/ThanxAIHelpLinks'
import ThanxAIPrompt from 'components/AI/ThanxAIPrompt'
import { buildTranslate } from 'locales'

import './AISegmentBuilderEmptyState.scss'

const t = buildTranslate('segments.ai_builder.empty_state')

export interface AISegmentBuilderEmptyStateProps {
  onPromptSubmit: (prompt: string) => void
}

const AISegmentBuilderEmptyState = ({
  onPromptSubmit,
}: AISegmentBuilderEmptyStateProps) => {
  const helpLinksData = [
    {
      url: 'https://help.thanx.com/hc/en-us/articles/30974499310871-Comprehensive-Segmentation-Attributes-Guide',
      text: t('help_link_1_text'),
    },
    {
      url: 'https://help.thanx.com/hc/en-us/articles/36348438692503-AI-Segment-Builder',
      text: t('help_link_2_text'),
    },
  ]

  const helpLinkTextAction = {
    url: 'https://thanxwiki.notion.site/43616f27eefa4fda85a1b18e4c619dfe?pvs=105',
    text: t('help_link_action_text'),
  }

  return (
    <main
      className="ai-segment-builder-empty-state"
      role="main"
      aria-label={t('aria_label_main')}
    >
      <section
        className="ai-segment-builder-empty-state__prompt"
        aria-label={t('aria_label_form')}
      >
        <ThanxAIPrompt
          title={t('title')}
          subtitle={t('subtitle')}
          placeholder={t('placeholder')}
          suggestions={[
            t('suggestion_1'),
            t('suggestion_2'),
            t('suggestion_3'),
          ]}
          onSubmit={onPromptSubmit}
          submitText={t('submit_text')}
        />
      </section>
      <aside className="ai-segment-builder-empty-state__help-links-container">
        <ThanxAIHelpLinks
          helpLinks={helpLinksData}
          helpLinkText={t('help_link_text')}
          helpLinkTextAction={helpLinkTextAction}
        />
      </aside>
    </main>
  )
}

export default AISegmentBuilderEmptyState
